import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@material-ui/core';
import { Reply } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';
import DataTable from '../../../../components/DataTable/DataTable';
import ResponseDialog from '../ResponseDialog/ResponseDialog';

const useStyles = makeStyles(theme => ({
    button: {
        textTransform: 'none',
        color: '#3f51b5',
    },
}));
function RequestTab(props) {
    const { open, fetchData, setOpen, customColumn, setCustomColumn, searchData, loading, setSearchKeyData } = props;
    const { t } = useTranslation();
    const classes = useStyles();
    const [clickedItem, setClickedItem] = useState({});


    const handleReplyClick = (dataIndex) => {
        setClickedItem(searchData[dataIndex]);
        setOpen(true);
    };

    useEffect(() => {
        const column = [
            {
                id: -1,
                label: "",
                name: "",
                options: {
                    filter: false,
                    sort: false,
                },
            },
            {
                id: 0,
                name: "connection_request_id",
                label: " ",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRenderLite: (dataIndex, rowIndex) => {
                        if (searchData && searchData[dataIndex]) {
                            return <span>{dataIndex + 1}.</span>;
                        }
                    },
                },
            },
            {
                id: 1,
                name: 'connection_name',
                label: t('CONTENT.DATATABLE.COLUMNS.CREDENTIAL_NAME'),
                options: { filter: true, sort: true }
            }, {
                id: 2,
                name: 'request_status',
                label: t('CONTENT.DATATABLE.COLUMNS.REQUEST_STATUS'),
                options: { filter: true, sort: false }
            }, {
                id: 3,
                name: 'requester_full_name',
                label: t('CONTENT.REQUEST-TAB.REQUESTER_FULL_NAME'),
                options: { filter: true, sort: true }
            }, {
                id: 4,
                name: 'requester_mail',
                label: t('CONTENT.REQUEST-TAB.REQUESTER_MAIL'),
                options: { filter: true, sort: true }
            }, {
                id: 5,
                name: 'actions',
                label: t('CONTENT.CREDENTIAL-TAB.ACTIONS'),
                options: {
                    filter: false, sort: false,
                    customBodyRenderLite: (dataIndex, rowIndex) => {
                        if (searchData && searchData[dataIndex]) {
                            return (
                                <Button disabled={open} className={classes.button} onClick={() => { handleReplyClick(dataIndex); }}>
                                    <Reply />
                                </Button>
                            );
                        }
                    },
                }
            }];
        setCustomColumn(column)
        setSearchKeyData(["connection_name", "requester_full_name", "requester_mail", "request_status"])
    }, [searchData])


    return (
        <div id="requesttab-container" data-test="request-tab">
            <DataTable
                className="request-table"
                data-test="request-table"
                customColumns={customColumn}
                selectableRows={"none"}
                //selectableRows="multiple"
                data={searchData}
                title={t('CONTENT.REQUEST-TAB.REQUEST-LIST')}
                loading={loading}
            />
            {open && <ResponseDialog setOpen={setOpen} fetchData={fetchData} clickedItem={clickedItem} tabIndex={1} />}
        </div>
    );
}

export default RequestTab;
